export function isBmbChangeOrQrFlow(
  hostRsp: { BMB?: string | number } | null | undefined
): boolean {
  const bmb = hostRsp?.BMB;
  return bmb === '2' || bmb === 2 || bmb === '5' || bmb === 5;
}
